export const EMPTY = 0;
export const BLACK = 1;
export const WHITE = 2;

export type Cell = typeof EMPTY | typeof BLACK | typeof WHITE;
export type Board = Cell[][];
export type Player = typeof BLACK | typeof WHITE;
export type GameStatus = 'waiting' | 'playing' | 'finished';

export interface Game {
  id: string;
  created_at: number;
  updated_at: number;
  creator_id: string;
  player1_id: string;
  player2_id: string | null;
  current_player: 1 | 2;
  board: Board;
  status: GameStatus;
  winner: 1 | 2 | null;
}

export interface GameListItem {
  id: string;
  creator_id: string;
  creator_name: string;
  status: GameStatus;
  player_count: number;
  created_at: number;
}

export interface PlayerSession {
  sessionId: string;
  name: string;
}

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

export interface GameCreateResponse {
  id: string;
  message: string;
}

export interface MoveResponse {
  message: string;
  scores: {
    black: number;
    white: number;
  };
} 